(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-full-footer"]) return;
  try {
    
  (function () {
    var msg = document.getElementById('gau-newsletter-message');
    var msgText = document.getElementById('gau-newsletter-message-text');
    var hideTimer;

    function showMessage(text, isError) {
      if (!msg) return;
      msg.classList.toggle('gau-footer__newsletter-message--error', !!isError);
      if (msgText) msgText.textContent = text;
      msg.hidden = false;
      clearTimeout(hideTimer);
      window.requestAnimationFrame(function () {
        msg.classList.add('is-visible');
      });
      hideTimer = setTimeout(function () {
        msg.classList.remove('is-visible');
        setTimeout(function () {
          msg.hidden = true;
        }, 320);
      }, 4500);
    }

    // Point the form back at this exact page (with a success flag) so Shopify's
    // normal full-page redirect after posting to /contact lands the visitor
    // right back here, and we can show the popup below.
    var returnToInput = document.getElementById('gau-newsletter-return-to');
    if (returnToInput) {
      var url = new URL(window.location.href);
      url.searchParams.set('subscribed', 'true');
      url.hash = 'gau-newsletter';
      returnToInput.value = url.pathname + url.search + url.hash;
    }

    // After the redirect back, detect the success flag, show the popup, and
    // clean the URL so refreshing the page doesn't re-show it.
    var currentParams = new URLSearchParams(window.location.search);
    if (currentParams.get('subscribed') === 'true') {
      showMessage("Thanks! You're subscribed.", false);
      currentParams.delete('subscribed');
      var cleanUrl = window.location.pathname +
        (currentParams.toString() ? '?' + currentParams.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, document.title, cleanUrl);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
